import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { Slide } from 'pure-react-carousel';
import CarouselSlider from 'components/atoms/TemplateCarouselSlider';
/**
 * ImageButtonCarousel
 */
const ImageBtnCarousel = ({ boxStyle, item, viewType, onClickEvt }) => {
  const { items, type, id } = item;
  const slideBoxSet = boxStyle;
  const slideBoxSetStyle = {
    width: `${slideBoxSet.width}px`,
    height: slideBoxSet.height,
    margin: `0 ${slideBoxSet.margin}px`,
  };
  const buttonStyle = {
    width: `${slideBoxSet.width}px`,
    height: slideBoxSet.height,
    fontSize: slideBoxSet.fontSize,
  }
  const slideLength = items.length;
  // console.log(items)
  const constentSet = () => {
    return (
      <>
        {items.map((tempItem, idx) => {
          return (
            <Slide key={`slide_${idx}`} index={idx} className="_image_btn_card" style={slideBoxSetStyle}>
              <div className="_image_butt ons_carousel_div">
                <button type="button"
                  key={`${id}_${idx}`}
                  style={buttonStyle}
                  className="_button"
                  onClick={e => onClickEvt(tempItem.image_btn.value, tempItem.image_btn.action, tempItem.image_btn.label)}
                >
                  <div className="_label">
                    <div className="_txt">{ReactHtmlParser(tempItem.image_btn.label)}</div>
                  </div>
                  <div className="_image_box">{ReactHtmlParser(tempItem.image_btn.image)}</div>
                </button>
              </div>
            </Slide>
          );
        })}
      </>
    );
  };
  return (
    <>
      <div className="_carousel_button_div">
        <CarouselSlider slideBoxSet={slideBoxSet} contentCount={slideLength} contentSet={constentSet} />
      </div>
    </>
  );
};
ImageBtnCarousel.propTypes = {
  boxStyle: PropTypes.object,
  item: PropTypes.object,
  viewType: PropTypes.string,
  onClickEvt: PropTypes.func,
};
ImageBtnCarousel.defaultProps = {
  boxStyle: {},
  item: {},
  viewType: 'advise', // advise, simulator, knowledge
  onClickEvt: null,
};

export default ImageBtnCarousel;
